const state = {
    
    blocks:[
        {
            id:1,
            name:'',
            color:'#fff',
            columns:1,
            blockcomponents: {
                columns: [
                    //left column
                    [
                        {
                            id:1,
                            name:'forminput',
                            attributes:{
                                    placeholder:"Name",
                                    size:"xs10",
                                    invertedsize:"xs1",
                                    hint:"Bitte den Namen eingeben",
                                    icon:"edit",
                                    variable: 'name',
                                    setter: 'tags/TAG_SET_NAME',
                                    rules:"required"                                    
                            }
                        },
                        {
                            id:1,
                            name:'formselect',
                            attributes: {
                                placeholder:"Kategorie",
                                size:"xs4",
                                invertedsize:"xs7",
                                displaytitle:"name",
                                displaysubtitle:"",
                                multiple:true,
                                icon:"search",
                                variable: 'tagcategory_ids',
                                setter: 'tags/TAG_SET_TAGCATEGORIES',
                                items:'tagcategories/tagcategories',
                                withdialog:false,
                            }                                    
                        },                                           
                    ],                   
                                     
                ]
            }
        }
    ]

};

export default {
  namespaced: false,
  state,
  
};